var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertInformationCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4434_1284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 21.2936C17.1285 21.2936 21.2858 17.1363 21.2858 12.0079C21.2858 6.87953 17.1285 2.72217 12.0001 2.72217C6.87171 2.72217 2.71436 6.87953 2.71436 12.0079C2.71436 17.1363 6.87171 21.2936 12.0001 21.2936Z",
    stroke: "#004C97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85718 16.2935H14.1429M12 16.2935V11.2935H10.5715M12 8.43638C12.3945 8.43638 12.7143 8.11658 12.7143 7.7221C12.7143 7.32761 12.3945 7.00781 12 7.00781C11.6055 7.00781 11.2857 7.32761 11.2857 7.7221C11.2857 8.11658 11.6055 8.43638 12 8.43638Z",
    stroke: "#004C97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4434_1284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2.00781)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInformationCircle);
export default __webpack_public_path__ + "static/media/alert-information-circle.8fa1b93be9aa0092f6b7bc898fbf7915.svg";
export { ForwardRef as ReactComponent };